import React from "react";
import JoyRide from "react-joyride";
import { isMobileBrowser } from "../../../base/environment/utils";
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3, tourGuideActions, tourGuideVisibilityActions } from "../../constant";
import { setCustomTourAction } from "../../redux/tool-webjam-v2/actions";
import { setTourGuideType, setTourGuideVisibility } from "../../redux/tool-webjam-v3/actions";
import { dispatch, getStore } from "../../Utils";
import { ct } from "../../constant-Utils";

// Tour steps
const TOUR_STEPS_WITH_DEVICE = [
  {
    target: ".subject-text",
    content: "rta-trmc.tourStepWithDevice.first",
    disableBeacon: true,
  },
  {
    target: ".toolbar-participants",
    content: "rta-trmc.tourStepWithDevice.second",
    disableBeacon: true,
  },
  {
    target: ".lighting-green",
    content: "rta-trmc.tourStepWithDevice.third",
    disableBeacon: true,
  },
  // {
  //   target: ".social-web-link-container",
  //   content: "Click here to explore the RealTime Audio Social network. Meet musicians, form bands, record songs, promote shows, and stream live to your fans.",
  //   disableBeacon: true,
  // },
  {
    target: ".sidebar-profile-menu-button",
    content: "rta-trmc.tourStepWithDevice.fourth",
    disableBeacon: true,
  },
];

const TOUR_STEPS_WITHOUT_DEVICE = [
  {
    target: ".subject-text",
    content: "rta-trmc.tourStepWithoutDevice.first",
    disableBeacon: true,
  },
  {
    target: ".lighting-white",
    content: "rta-trmc.tourStepWithoutDevice.second",
    disableBeacon: true,
  },
  {
    target: ".toolbar-music-mode",
    content: "rta-trmc.tourStepWithoutDevice.third",
    disableBeacon: true,
  },
  {
    target: ".toolbar-participants",
    content: "rta-trmc.tourStepWithoutDevice.fourth",
    disableBeacon: true,
  },
  // {
  //   target: ".social-web-link-container",
  //   content: "Click here to explore the RealTime Audio Social network. Meet musicians, form bands, record songs, promote shows, and stream live to your fans.",
  //   disableBeacon: true,
  // },
  {
    target: ".sidebar-profile-menu-button",
    content: "rta-trmc.tourStepWithoutDevice.fifth",
    disableBeacon: true,
  },
];

// // For Mobile
// const MOBILE_TOUR_STEPS_WITHOUT_DEVICE = [
//   {
//     target: ".subject-text",
//     content: "Welcome to the RealTime Audio Webcam App. We notice you have not connected a RTA device. Though this means you won’t be able to jam in real - time, the RTA webcam app is still the premiere web conferencing solution for musicians. Click below for a guided tour to find out why.",
//     disableBeacon: true,
//   },
//   {
//     target: ".lighting-white",
//     content: "Did you know this app can be paired with a RealTime Audio powered device? This allows you to jam with other musicians in real-time up to 1,000 miles away like you were in the room together!",
//     disableBeacon: true,
//   },
//   {
//     target: ".toolbar-music-mode",
//     content: "Don’t have a RTA device for ultra-low latency? No worries. Click here to access a ton of other great music tools.",
//     disableBeacon: true,
//   },
//   {
//     target: ".toolbar-participants",
//     content: "Click here to invite friends.",
//     disableBeacon: true,
//   },
//   // {
//   //   target: ".social-web-link-container",
//   //   content: "Click here to explore the RealTime Audio Social network. Meet musicians, form bands, record songs, promote shows, and stream live to your fans.",
//   //   disableBeacon: true,
//   // },
//   {
//     target: ".bm-burger-button",
//     content: "Click here to access your webcam settings, rooms, subscriptions, and more...",
//     disableBeacon: true,
//   },
// ];



// Tour component
const CustomTour = () => {
  // let usersData = getStore(FEATURE_CUSTOM_REDUX).usersData

  // Commented as need to keep 4 steps in all cases
  // if (isMobileBrowser()) {
  //   TOUR_STEPS = MOBILE_TOUR_STEPS_WITHOUT_DEVICE;
  // } else {
  //   if (usersData?.users?.length > 0) {
  //     TOUR_STEPS = TOUR_STEPS_WITH_DEVICE;
  //   } else {
  //     TOUR_STEPS = TOUR_STEPS_WITHOUT_DEVICE;
  //   }
  // }

  let tourGuideVisibility = getStore(FEATURE_CUSTOM_REDUX_V3).tourGuideVisibility
  let TOUR_STEPS;

  if (tourGuideVisibility == tourGuideVisibilityActions.TOUR_WITHOUT_DEVICE) {
    TOUR_STEPS = TOUR_STEPS_WITHOUT_DEVICE;
  } else if (tourGuideVisibility == tourGuideVisibilityActions.TOUR_WITH_DEVICE) {
    TOUR_STEPS = TOUR_STEPS_WITH_DEVICE;
  }


  const handleTourCallback = (data) => {
    let mixer = document.getElementById("mixer-tab");

    if (data.action == 'reset') {
      dispatch(setCustomTourAction(false))
      localStorage.setItem("showTourGuide", 'false')
      dispatch(setTourGuideType(tourGuideActions.USER_EMPTY))
      dispatch(setTourGuideVisibility(tourGuideVisibilityActions.TOUR_EMPTY))
      if (mixer) {
        mixer.style.removeProperty('margin-top');
        mixer.style.removeProperty('margin-bottom');
      }
    } else {
      if (mixer) {
        if (data.step?.target) {
          switch (data.step?.target) {
            case ".subject-text": {

              if (mixer) {
                mixer.style.marginTop = "50px"
                mixer.style.removeProperty('margin-bottom');
              }

              break;
            }
            case ".toolbar-participants":
            case ".lighting-green": {

              if (mixer) {
                mixer.style.marginBottom = "50px"
                mixer.style.removeProperty('margin-top');
              }
              break;
            }

            case ".sidebar-profile-menu-button": {

              if (mixer) {
                mixer.style.marginTop = "70px"
                mixer.style.removeProperty('margin-bottom');
              }

              break;
            }

            default: {
              if (mixer) {
                mixer.style.removeProperty('margin-top');
                mixer.style.removeProperty('margin-bottom');
              }
            }

          }
        }
      }
    }
  }

  return (
    <>
      <JoyRide
        steps={TOUR_STEPS.map((s) => {
          return { ...s, content: ct(s.content) }
        })}
        continuous={true}
        showSkipButton={true}
        showProgress={true}
        hideCloseButton={true}
        locale={{ back: ct("Translate.buttonTitle.backSmall"), next: ct("Translate.buttonTitle.next"), skip: ct("Translate.buttonTitle.skip"), last: ct("Translate.buttonTitle.last") }}
        callback={(data) => handleTourCallback(data)}
        styles={{
          buttonNext: {
            backgroundColor: "var(--theme-button-bgcolor)"
          },
          options: {
            zIndex: 1000,
          },
          transition: "opacity 1s ease 2s, transform 2s ease 1s !important"
        }}
      />
    </>
  );
};
export default CustomTour;